import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubArticleInCategoryRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-article-in-category',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId',
};
